import axios from 'axios'

import { Channel } from 'types'

export const getChannels = async () => {
  return (await axios.get<Channel[]>('/channels')).data
}
